"use client";

import { PortalFlowHostProvider } from "@offstreetparking/portal-flow/host";
import type { ReactNode } from "react";
import { PaymentGatewayPanel } from "~/components/PaymentGateways/PaymentGatewayPanel";
import { SignInPrompt } from "~/components/SignInPrompt";
import { CommonLayout } from "~/components/layouts/CommonLayout";

export const PortalFlowHost = ({ children }: { children: ReactNode }) => (
	<PortalFlowHostProvider shell={CommonLayout} paymentGatewayPanel={PaymentGatewayPanel} signInPrompt={SignInPrompt}>
		{children}
	</PortalFlowHostProvider>
);
